import { render } from "./LessonEdit.vue?vue&type=template&id=10ad955e&scoped=true"
import script from "./LessonEdit.vue?vue&type=script&lang=js"
export * from "./LessonEdit.vue?vue&type=script&lang=js"

import "./LessonEdit.vue?vue&type=style&index=0&id=10ad955e&lang=scss&scoped=true"

import exportComponent from "/Users/mohamedyousef/projects/online_education/projects/web-applications/admin-panel-for-education-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ad955e"]])

export default __exports__